export default __webpack_public_path__ + "static/media/logo-alt-1.81c1df33.svg";